import { render, staticRenderFns } from "./SecondaryUserPush.vue?vue&type=template&id=6afe8590&scoped=true&"
import script from "./SecondaryUserPush.vue?vue&type=script&lang=js&"
export * from "./SecondaryUserPush.vue?vue&type=script&lang=js&"
import style0 from "./SecondaryUserPush.vue?vue&type=style&index=0&id=6afe8590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afe8590",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6afe8590')) {
      api.createRecord('6afe8590', component.options)
    } else {
      api.reload('6afe8590', component.options)
    }
    module.hot.accept("./SecondaryUserPush.vue?vue&type=template&id=6afe8590&scoped=true&", function () {
      api.rerender('6afe8590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/SecondaryUsers/SecondaryUserPush.vue"
export default component.exports